<fuse-vertical-navigation class="bg-card dark:bg-gray-900 print:hidden" [appearance]="'thin'"
  [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="data.navigation.compact"
  [opened]="!isScreenSmall">
  <ng-container fuseVerticalNavigationContentHeader>
  </ng-container>
</fuse-vertical-navigation>

<div class="flex flex-col flex-auto w-full min-w-0">
  <div
    class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
    <button class="mr-2" mat-icon-button (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
    </button>

    <a [routerLink]="['/home']">
      <img class=" w-18" alt="IAPMO SCB Certification Management Database" src="assets/images/logo/logo_SCB.jpg">
    </a>
    <h1 class="text-4xl ml-4 text-accent font-bold italic">{{currentRole}}</h1>
    <!-- Components -->
    <div class="flex items-center pl-2 ml-auto space-x-2">
      @if (!isScreenSmall) {
        <fuse-fullscreen></fuse-fullscreen>
      }
      <notifications [notifications]="data.notifications"></notifications>
      <user-menu></user-menu>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto">

    <mat-drawer-container class="flex-auto sm:h-full">

      <!-- Drawer -->
      <mat-drawer class="sm:w-96 dark:bg-gray-900" [autoFocus]="false" [mode]="drawerMode" [opened]="drawerOpened"
        #drawer>
        <!-- Header -->
        <div class="flex items-center justify-between m-8 mr-6 sm:my-10">
          <!-- Title -->
          <div class="text-4xl font-extrabold tracking-tight leading-none flex flex-row items-center">
            <mat-icon [svgIcon]="moduleIcon" class="icon-size-10 mr-4"></mat-icon>
            {{moduleTitle}}
          </div>
          <!-- Close button -->
          <div class="lg:hidden">
            <button mat-icon-button (click)="drawer.close()">
              <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
            </button>
          </div>
        </div>
        <!-- Panel links -->
        <div class="flex flex-col divide-y border-t border-b">
          @for (panel of panels; track trackByFn($index, panel)) {
                        <div class="flex px-8 py-5 cursor-pointer" [ngClass]="{'hover:bg-gray-100 dark:hover:bg-hover': !selectedPanel || selectedPanel !== panel.id,
                                        'bg-primary-50 dark:bg-hover': selectedPanel && selectedPanel === panel.id}"
              [routerLink]="panel.id">
              <mat-icon
                                [ngClass]="{'text-hint': !selectedPanel || selectedPanel !== panel.id,
                                            'text-primary dark:text-primary-500': selectedPanel && selectedPanel === panel.id}"
              [svgIcon]="panel.icon"></mat-icon>
              <div class="ml-3">
                <div class="font-medium leading-6"
                  [ngClass]="{'text-primary dark:text-primary-500': selectedPanel && selectedPanel === panel.id}">
                  {{panel.title}}
                </div>
                <div class="mt-0.5 text-secondary">
                  {{panel.description}}
                </div>
              </div>
            </div>
          }
        </div>
      </mat-drawer>

      <!-- Drawer content -->
      <mat-drawer-content class="flex flex-col">

        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
        Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
          <router-outlet></router-outlet>
        }

      </mat-drawer-content>

    </mat-drawer-container>
  </div>
</div>
